import React from 'react';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import './Modal.css';

export const ModalPopup = ({
  buttonContent,
  title,
  modalContent,
  modalButtonId,
  open,
  handleClose,
  handleOpen,
}) => {
  return (
    <>
      <Button id={modalButtonId} onClick={handleOpen}>
        {buttonContent}
      </Button>
      <Modal
        className="modal-pop-up-wrapper"
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableAutoFocus={true}
      >
        <Box
          className="dashboard-modal-popup survey-modal-popup"
          sx={{
            borderRadius: 3,
            padding: 1,
            ml: 'auto',
            mr: 'auto',
            maxWidth: 600,
            bgcolor: 'white',
          }}
        >
          <div className="modal-title-close-button-wrapper">
            <div className="modal-title">{title}</div>
            <div>
              <IconButton
                onClick={handleClose}
                sx={{
                  '&:hover': { backgroundColor: 'black', color: 'white' },
                  backgroundColor: 'black',
                  color: 'white',
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <Typography variant="div" sx={{ mt: 0, bgcolor: 'white' }}>
            {modalContent}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};
